import {useState} from 'react';
import {adjust, assoc} from 'ramda';
import {useLocation} from 'react-router-dom';

const toggleProp = prop => v => assoc(prop, !v[prop], v);

export const useToggleState = (
  initialState = [],
  {keyField = 'label', toggleField = 'checked'} = {},
) => {
  const [state, setState] = useState(initialState);
  return [
    state,
    value => {
      const idx = state.findIndex(x => x[keyField] === value);
      if (idx === -1) {
        return;
      }
      setState(adjust(idx, toggleProp(toggleField), state));
    },
  ];
};

export const useQueryString = () => {
  const location = useLocation();
  return new URLSearchParams(location.search);
};
